var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.ui.layout,{tag:"component"}),(!_vm.isOnline)?_c('div',{staticClass:"offline black"},[_vm._v("Tanpa koneksi")]):_vm._e(),(_vm.displayOnline)?_c('div',{staticClass:"offline green"},[_vm._v("Kembali online")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }